import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SamirsImage from "../icons/Samirs_image.jpg";

const Header = () => {
	return (
		<HeaderStyle>
			<div className="">
				<div className="header-content">
					<Link to="/">
						<img src={SamirsImage} alt="Samir Felfel" className="profile-img" />
						<span>Samir Felfel</span>
					</Link>
				</div>
			</div>
		</HeaderStyle>
	);
};

const HeaderStyle = styled.header`
	width: 100%;
	left: 0;
	position: absolute;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 30px 0;
	z-index: 2;

	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	a {
		display: flex;
		align-items: center;
		gap: 10px;
		font-family: 'Marck Script', cursive;
		text-transform: capitalize;
		font-size: 25px;
		color: white;
		text-decoration: none;
	}

	.profile-img {
		width: 70px;
		height: 70px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid white;
		transition: transform 0.3s ease;

		&:hover {
			transform: scale(1.05);
		}
	}
`;

export default Header;
